var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayer = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M14 18a4 4 0 0 1 4 4v1H6v-1a4 4 0 0 1 4-4zM5.978 17.3c.508 0 .982.143 1.388.386a5.7 5.7 0 0 0-2.544 3.006H.551v-.678A2.713 2.713 0 0 1 3.264 17.3zM20.287 17.3A2.713 2.713 0 0 1 23 20.015v.678h-3.822a5.7 5.7 0 0 0-2.77-3.127 2.7 2.7 0 0 1 1.166-.264zM12 10a3 3 0 1 1 0 6 3 3 0 0 1 0-6M4.62 11.875a2.035 2.035 0 1 1 0 4.07 2.035 2.035 0 0 1 0-4.07M18.93 11.875a2.034 2.034 0 1 1 0 4.069 2.034 2.034 0 0 1 0-4.069M14.5 4 17 3l-1 6H8L7 3l2.5 1L12 1z"
})));
export default SvgPlayer;